<script setup lang="ts">
import { ref } from 'vue'
import type { LocaleCode } from '../i18n'
import { currentLocale, SUPPORTED_LOCALES, setLocale } from '../i18n'

/**
 * Each language is listed in its own language — someone who has landed in the
 * wrong one cannot read a list written in it.
 */
const selected = ref<LocaleCode>(currentLocale())
const busy = ref(false)

async function change(event: Event): Promise<void> {
  const code = (event.target as HTMLSelectElement).value as LocaleCode
  busy.value = true
  try {
    // The catalog is fetched on demand, so this can fail offline; `setLocale`
    // reports what actually took effect.
    selected.value = await setLocale(code)
  } finally {
    busy.value = false
  }
}
</script>

<template>
  <section class="panel stack">
    <h2 class="title-md">{{ $t('settings.language') }}</h2>
    <label class="field">
      <span class="visually-hidden">{{ $t('settings.language') }}</span>
      <select class="select" :value="selected" :disabled="busy" @change="change">
        <option v-for="locale of SUPPORTED_LOCALES" :key="locale.code" :value="locale.code">
          {{ locale.label }}
        </option>
      </select>
    </label>
    <p class="hint">{{ $t('settings.languageHint') }}</p>
  </section>
</template>
